import React, { useState, useEffect } from 'react';
import './App.css';
import './mobile.css';
import './sidebar_v2.css';
import './tether.css';
import { supabase } from './supabase';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Charts from './pages/Charts';
import Journal from './pages/Journal';
import Scanner from './pages/Scanner';
import Profile from './pages/Profile';
import Pricing from './pages/Pricing';
import GrooveTrader from './pages/ActiveTrader';
import AIIndicators from './pages/AIIndicators';

const SCAN_LIBRARY = [
  { category:'🔥 Small Cap', scans:[
    {id:'sc_5pillars',    label:'5 Pillar Momentum Scan',      desc:'All 5 criteria: $1-$20 · >10% · RVOL>5x · Float<50M · News catalyst'},
    {id:'sc_topgainers',  label:'Top Gainers',               desc:'Largest % moves — updates all day'},
    {id:'sc_momentum',    label:'High of Day Momentum',      desc:'New HOD with above-avg momentum · Price $1-$20'},
    {id:'sc_runningup',   label:'Running Up Alert',          desc:'Quick moves up — faster than HOD · Best 7-9am ET'},
    {id:'sc_gappers',     label:'Top Gappers',               desc:'Gapping >4% from previous close'},
    {id:'sc_lowfloat',    label:'Low Float Top Gainers',     desc:'Float under 10M — sub-5M is rocket fuel'},
    {id:'sc_penny',       label:'Penny Top Gainers',         desc:'Under $2.00 — highest % penny movers'},
    {id:'sc_halts',       label:'Halt Scanner',              desc:'Current and past halts today'},
    {id:'sc_runningdown', label:'Running Down Alert',        desc:'Quick moves down — short candidates'},
    {id:'sc_reversal',    label:'Reversal Scanner',          desc:'Red-to-green major price turns'},
    {id:'sc_afthours',    label:'After Hours Top Gainers',   desc:"Moving 4-8pm — tomorrow's watchlist"},
    {id:'sc_continuation',label:'Continuation Setup',        desc:'Previous day runners setting up again'},
  ]},
  { category:'📊 Large Cap', scans:[
    {id:'sc_largecap_hod',label:'Large Cap HOD Momentum',   desc:'New HOD on large cap stocks'},
    {id:'lc_earnings',    label:'Earnings Movers',          desc:'Post-earnings momentum plays'},
    {id:'lc_unusual_vol', label:'Unusual Volume',           desc:'Institutional volume spikes 3x+'},
    {id:'lc_breakout',    label:'Breakouts',                desc:'Breaking key resistance levels'},
    {id:'lc_oversold',    label:'Oversold Bounce',          desc:'RSI under 30 bouncing back'},
    {id:'lc_52high',      label:'52-Week Highs',            desc:'New all-time breakouts'},
  ]},
  { category:'📈 Technical', scans:[
    {id:'te_vwap_hold',   label:'VWAP Hold',                desc:'Holding above VWAP all day'},
    {id:'te_ema9_cross',  label:'EMA 9 Crossover',          desc:'Price crossing above EMA 9'},
    {id:'te_ema20_bounce',label:'EMA 20 Bounce',            desc:'Bouncing off EMA 20 support'},
    {id:'te_bb_squeeze',  label:'Bollinger Band Squeeze',   desc:'Volatility compression breakout'},
    {id:'te_macd_bull',   label:'MACD Bullish Cross',       desc:'MACD crossing signal line up'},
    {id:'te_orb',         label:'Opening Range Breakout',   desc:'Breaking first 15min high'},
    {id:'te_power_hour',  label:'Power Hour Setup',         desc:'3-4pm momentum plays'},
    {id:'te_consolidation',label:'Consolidation Break',     desc:'Breaking out of tight range'},
  ]},
  { category:'⏰ Time Based', scans:[
    {id:'tb_premarket',   label:'Pre-Market (4-9:30am)',    desc:'Active before market open'},
    {id:'tb_open_drive',  label:'Open Drive (9:30-10am)',   desc:'First 30 min momentum'},
    {id:'tb_midday',      label:'Midday Momentum',          desc:'11am-2pm breakouts'},
    {id:'tb_power_hour',  label:'Power Hour (3-4pm)',       desc:'End of day momentum surge'},
    {id:'tb_afterhours',  label:'After Hours (4-8pm)',      desc:'After hours movers'},
    {id:'tb_continuation',label:'Next Day Continuation',    desc:'Previous day runner setups'},
  ]},
  { category:'🏦 By Sector', scans:[
    {id:'sec_biotech',    label:'Biotech / Healthcare',     desc:'FDA, clinical trials, biotech news'},
    {id:'sec_tech',       label:'Technology',               desc:'Tech sector momentum movers'},
    {id:'sec_crypto',     label:'Crypto Related',           desc:'Bitcoin miners, crypto stocks'},
    {id:'sec_ev',         label:'EV / Clean Energy',        desc:'Electric vehicle plays'},
    {id:'sec_energy',     label:'Energy / Oil',             desc:'Energy sector momentum'},
    {id:'sec_ai',         label:'AI / Machine Learning',    desc:'Artificial intelligence plays'},
  ]},
  { category:'📰 News Driven', scans:[
    {id:'nw_fda',         label:'FDA Catalyst',             desc:'FDA approval or rejection news'},
    {id:'nw_earnings_pre',label:'Earnings This Week',       desc:'Upcoming earnings setups'},
    {id:'nw_merger',      label:'Merger / Acquisition',     desc:'M&A announcement plays'},
    {id:'nw_sec_filing',  label:'SEC Filing Alert',         desc:'Form 4, 8-K material events'},
    {id:'nw_short',       label:'High Short Interest >20%', desc:'Short squeeze candidates'},
    {id:'nw_insider',     label:'Insider Buying',           desc:'Insiders buying their own stock'},
    {id:'nw_upgrades',    label:'Analyst Upgrades',         desc:'Buy rating upgrades today'},
    {id:'nw_halt_resume', label:'Halt & Resume',            desc:'Stocks resuming after halt'},
  ]},
];

function ScannerDropdown({ onSelect, activeScanId }) {
  const [openCat, setOpenCat] = useState('🔥 Small Cap');
  return (
    <div className="scan-dropdown">
      {SCAN_LIBRARY.map(cat=>(
        <div key={cat.category}>
          <div className="scan-cat-header" onClick={()=>setOpenCat(openCat===cat.category?null:cat.category)}>
            <span>{cat.category}</span>
            <span style={{fontSize:9,color:'#484f58'}}>{openCat===cat.category?'▲':'▼'}</span>
          </div>
          {openCat===cat.category&&(
            <div className="scan-cat-items">
              {cat.scans.map(scan=>(
                <div key={scan.id} className={`scan-item ${activeScanId===scan.id?'active-scan':''}`} onClick={()=>onSelect(scan.id)}>
                  <div className="scan-item-label">
                    {activeScanId===scan.id&&<span style={{color:'#2563eb',marginRight:4}}>▶</span>}
                    {scan.label}
                  </div>
                  <div className="scan-item-desc">{scan.desc}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

// ── BROKER PICKER DROPDOWN ──
function BrokerDropdown({ activeBroker, onSelect }) {
  const brokers = [
    {
      id: 'groove',
      name: 'Groove Trader',
      color: '#2563eb',
      desc: 'Live Level 2 · Buy/Sell/Short · Bracket orders · Hotkeys F1-F6 · Pre & after market',
      logo: 'GT',
    },
  ];

  return (
    <div className="broker-dropdown">
      <div className="broker-dd-title">Select Broker Style</div>
      <div className="broker-dd-desc">Practice order execution exactly like your real broker</div>
      {brokers.map(b=>(
        <div
          key={b.id}
          className={`broker-dd-item ${activeBroker===b.id?'active':''}`}
          style={{borderLeft:`3px solid ${b.color}`}}
          onClick={()=>onSelect(b.id)}
        >
          <div className="broker-dd-logo" style={{background:b.color}}>{b.logo}</div>
          <div className="broker-dd-info">
            <div className="broker-dd-name" style={{color:activeBroker===b.id?b.color:'#e6edf3'}}>{b.name}</div>
            <div className="broker-dd-desc-sm">{b.desc}</div>
          </div>
          {activeBroker===b.id&&<span style={{color:b.color,fontSize:14}}>●</span>}
        </div>
      ))}
      {activeBroker&&(
        <div className="broker-dd-close-btn" onClick={()=>onSelect(null)}>
          Close Panel
        </div>
      )}
    </div>
  );
}

const NAV = [
  { section:'Rooms', items:[
    {id:'sc_room',  label:'Small Cap',    icon:'🔥', badge:'OFF AIR', badgeType:'off'},
    {id:'lc_room',  label:'Large Cap',    icon:'📊', badge:'OFF AIR', badgeType:'off'},
    {id:'sup_room', label:'Support',      icon:'💬', badge:'OFF AIR', badgeType:'off'},
    {id:'lng_room', label:'Lounge',       icon:'🛋', badge:'OFF AIR', badgeType:'off'},
    {id:'pro_room', label:'Pro Mentor',   icon:'🎓', badge:'LIVE',    badgeType:'live'},
    {id:'cls_room', label:'Live Classes', icon:'📚', badge:'OFF AIR', badgeType:'off'},
  ]},
  { section:'Tools', items:[
    {id:'scanners',    label:'Scanners',      icon:'🔍', page:'charts'},
    {id:'watchlist',   label:'My Watchlist',  icon:'👁', page:'charts'},
    {id:'charting',    label:'Charting',      icon:'📈', page:'charts'},
    {id:'journal',     label:'Trade Journal', icon:'📓', page:'journal'},
    {id:'papertrading',label:'Paper Trading', icon:'📋', page:'charts'},
    {id:'newsroom',    label:'News Room',     icon:'📰', page:'charts'},
    {id:'ai_indicators',label:'AI Indicators',  icon:'🤖', page:'ai'},
  ]},
  { section:'Settings', items:[
    {id:'layouts',  label:'Layouts',      icon:'⚙', page:'profile'},
    {id:'alertvol', label:'Alert Volume', icon:'🔔', page:'profile'},
    {id:'profile',  label:'Profile',      icon:'👤', page:'profile'},
    {id:'pricing',  label:'Pricing',      icon:'💳', page:'pricing'},
  ]},
];

export default function App() {
  const [page, setPage] = useState('landing');
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [expanded, setExpanded] = useState(true);
  const [showScannerMenu, setShowScannerMenu] = useState(false);
  const [showBrokerMenu, setShowBrokerMenu] = useState(false);
  const [activeScanId, setActiveScanId] = useState(null);
  const [activeBroker, setActiveBroker] = useState(null);
  const [atSym] = useState('AAPL');

  useEffect(()=>{
    supabase.auth.getSession().then(({data:{session}})=>{
      if(session?.user){
        setUser({name:session.user.user_metadata?.name||session.user.email.split('@')[0],email:session.user.email,id:session.user.id});
        setPage('charts');
      }
      setAuthLoading(false);
    });
    const {data:{subscription}}=supabase.auth.onAuthStateChange((_,session)=>{
      if(session?.user)setUser({name:session.user.user_metadata?.name||session.user.email.split('@')[0],email:session.user.email,id:session.user.id});
      else setUser(null);
    });
    return()=>subscription.unsubscribe();
  },[]);

  async function handleLogin(u){setUser(u);setPage('charts');}
  async function handleLogout(){await supabase.auth.signOut();setUser(null);setPage('landing');}

  if(authLoading)return(
    <div style={{height:'100vh',background:'#0d1117',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:12}}>
      <div style={{width:40,height:40,borderRadius:10,background:'linear-gradient(135deg,#2563eb,#7c3aed)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:700,color:'#fff'}}>GT</div>
      <div style={{fontSize:12,color:'#484f58'}}>Loading The Groove Trading...</div>
    </div>
  );

  if(page==='landing')return <Landing onEnter={()=>setPage('charts')} onLogin={()=>setPage('login')}/>;
  if(page==='login')  return <Login onLogin={handleLogin} onBack={()=>setPage('landing')}/>;
  if(page==='pricing')return <Pricing onBack={()=>setPage('charts')} user={user}/>;

  return(
    <div className="app">
      {/* ── COLLAPSIBLE SIDEBAR ── */}
      <div className={`sidebar-v2 ${expanded?'expanded':'collapsed'}`}>
        {/* LOGO */}
        <div className="sv2-logo">
          <div className="sv2-logo-icon">GT</div>
          {expanded&&<div className="sv2-logo-text"><div className="sv2-logo-name">The Groove</div><div className="sv2-logo-sub">Trading</div></div>}
          <button className="sv2-collapse-btn" onClick={()=>setExpanded(!expanded)}>{expanded?'◀':'▶'}</button>
        </div>

        {/* NAV */}
        <div className="sv2-nav">
          {NAV.map(section=>(
            <div key={section.section} className="sv2-section">
              {expanded&&<div className="sv2-section-label">{section.section}</div>}
              {section.items.map(item=>(
                <div key={item.id}>
                  <div
                    className={`sv2-item ${
                      (page===item.page&&item.id!=='scanners'&&item.id!=='papertrading'&&!item.badgeType)?'active':''
                    } ${item.id==='scanners'&&showScannerMenu?'active':''
                    } ${item.id==='papertrading'&&showBrokerMenu?'active':''}`}
                    onClick={()=>{
                      if(item.badgeType)return;
                      if(item.id==='scanners'){
                        setShowScannerMenu(s=>!s);
                        setShowBrokerMenu(false);
                        setPage('charts');
                      } else if(item.id==='papertrading'){
                        setShowBrokerMenu(s=>!s);
                        setShowScannerMenu(false);
                        setPage('charts');
                      } else {
                        setPage(item.page||'charts');
                        setShowScannerMenu(false);
                        setShowBrokerMenu(false);
                      }
                    }}
                    title={!expanded?item.label:''}
                  >
                    <span className="sv2-item-icon">{item.icon}</span>
                    {expanded&&(
                      <>
                        <span className="sv2-item-label">{item.label}</span>
                        {item.badge&&<span className={`sv2-badge ${item.badgeType==='live'?'live':'off'}`}>{item.badge}</span>}
                        {item.id==='scanners'&&<span style={{fontSize:9,color:'#484f58',marginLeft:'auto'}}>{showScannerMenu?'▲':'▼'}</span>}
                        {item.id==='scanners'&&activeScanId&&<span style={{width:6,height:6,borderRadius:'50%',background:'#22c55e',flexShrink:0}}></span>}
                        {item.id==='papertrading'&&<span style={{fontSize:9,color:'#484f58',marginLeft:'auto'}}>{showBrokerMenu?'▲':'▼'}</span>}
                        {item.id==='papertrading'&&activeBroker&&<span style={{width:6,height:6,borderRadius:'50%',background:'#22c55e',flexShrink:0}}></span>}
                      </>
                    )}
                  </div>

                  {/* SCANNER DROPDOWN */}
                  {item.id==='scanners'&&showScannerMenu&&expanded&&(
                    <ScannerDropdown
                      activeScanId={activeScanId}
                      onSelect={id=>{
                        setActiveScanId(activeScanId===id?null:id);
                        setPage('charts');
                      }}
                    />
                  )}

                  {/* BROKER DROPDOWN */}
                  {item.id==='papertrading'&&showBrokerMenu&&expanded&&(
                    <BrokerDropdown
                      activeBroker={activeBroker}
                      onSelect={broker=>{
                        setActiveBroker(broker);
                        if(broker) setPage('charts');
                      }}
                    />
                  )}
                </div>
              ))}
              {expanded&&<div className="sv2-divider"/>}
            </div>
          ))}
        </div>

        {/* USER */}
        <div className="sv2-user">
          {user?(
            <>
              <div className="sv2-avatar">{user.name.charAt(0).toUpperCase()}</div>
              {expanded&&<div className="sv2-user-info"><div className="sv2-user-name">{user.name}</div><div className="sv2-user-plan">Free Plan</div></div>}
              {expanded&&<button className="sv2-logout" onClick={handleLogout} title="Sign out">↩</button>}
            </>
          ):(
            <div className="sv2-item" onClick={()=>setPage('login')} style={{width:'100%'}}>
              <span className="sv2-item-icon">👤</span>
              {expanded&&<span className="sv2-item-label">Sign In</span>}
            </div>
          )}
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="main-content" style={{position:'relative'}}>
        {page==='charts'  && <Charts activeScanId={activeScanId} onScanClose={()=>setActiveScanId(null)}/>}
        {page==='journal' && <Journal user={user}/>}
        {page==='scanner' && <Scanner/>}
        {page==='profile' && <Profile user={user} onLogout={handleLogout} onPricing={()=>setPage('pricing')}/>}
        {page==='ai'      && <AIIndicators/>}

        {/* FLOATING ACTIVE TRADER PANEL — on top of everything */}
        {activeBroker&&<GrooveTrader sym={atSym} onClose={()=>setActiveBroker(null)}/>}
      </div>
    </div>
  );
}